//#region src/variants/variants_emoji_picker.js
var variants_emoji_picker_default = { default: { props: {
	skinTone: { initialValue: "Default" },
	skinSelectorButtonTooltipLabel: { initialValue: "Change default skin tone" },
	searchResultsLabel: { initialValue: "Search results" },
	searchNoResultsLabel: { initialValue: "No results" },
	searchPlaceholderLabel: { initialValue: "Search..." }
} } };
//#endregion
export { variants_emoji_picker_default as default };

//# sourceMappingURL=variants_emoji_picker.js.map